import { Injectable } from '@angular/core';
import { StorageProvider } from '../services/storage.provider';

@Injectable({ providedIn: 'root' })
export class Oneperweek {
  public pass: boolean;
  public remainingDays: number;
  private date: Date = new Date();
  private accessDatePlusSeven: Date = new Date(
    new Date().getTime() + 7 * 24 * 60 * 60 * 1000
  );

  constructor(private storage: StorageProvider) {}

  checkOnePerWeek(id: any, type: any, isExcludedFromPaywall?: boolean) {
    const self = this;
    let fiveFree: Array<any> = [];
    fiveFree = JSON.parse(localStorage.getItem('five'));
    let push: Array<any>;

    const loggedin = this.storage.getStorage('logged_profile_id');
    const access = this.storage.getStorage('access');

    if (
      /bot|google|googlebot|spider|robot|baidu|bing|msn|duckduckgo|teoma|slurp|yandex/i.test(
        navigator.userAgent
      )
    ) {
      this.pass = true;
    } else {
      if (!loggedin || (loggedin && !access)) {
        if (isExcludedFromPaywall) {
          this.pass = false;
        } else {
          if (!fiveFree) {
            this.pass = true;
            const free = [
              { item_id: id, item_type: type, date: this.accessDatePlusSeven },
            ];
            this.storage.setStorage('five', JSON.stringify(free));
          } else {
            const entity = {
              item_id: id,
              item_type: type,
              date: this.accessDatePlusSeven,
            };
  
            for (let i = 0; i < fiveFree.length; i++) {
              if (fiveFree[i].date < self.date.toISOString()) {
                fiveFree.splice(i, 1);
              }
            }
  
            if (fiveFree.length >= 5) {
              const present = this.checkResourcePresent(fiveFree, id, type);
              if (present) {
                this.pass = true;
              } else {
                this.pass = false;
                this.getRemainingDays(fiveFree);
              }
            }
  
            if (fiveFree.length < 5) {
              const present = this.checkResourcePresent(fiveFree, id, type);
              if (present) {
                this.pass = true;
              } else {
                if (this.checkType(type)) {
                  fiveFree.push(entity);
                  self.storage.setStorage('five', JSON.stringify(fiveFree));
                  self.pass = true;
                } else {
                  this.pass = false;
                  this.getRemainingDays(fiveFree);
                }
              }
            }
        }

        }
      }
      if (loggedin && access) {
        this.pass = true;
      }
    }
  }

  checkResourcePresent(array, id, type) {
    for (let i = 0; i < array.length; i++) {
      if (array[i].item_id === id && array[i].item_type === type) {
        return true;
      }
    }
  }

  checkResourceExpired(array, id, type) {
    const self = this;
    for (let i = 0; i < array.length; i++) {
      if (array[i].date < self.date) {
        return true;
      }
    }
  }

  getRemainingDays(array) {
    array.sort(compare);
    const oneDay = 24 * 60 * 60 * 1000;
    const currentDate = new Date();
    const accessDate = new Date(array[0].date);
    this.remainingDays = Math.ceil(
      Math.abs((currentDate.getTime() - accessDate.getTime()) / oneDay)
    );
    function compare(a, b) {
      if (new Date(a.date) < new Date(b.date)) {
        return -1;
      }
      if (new Date(a.date) > new Date(b.date)) {
        return 1;
      }

      return 0;
    }
  }

  checkType(type: string): boolean {
    const currentStorage: Array<any> = JSON.parse(localStorage.getItem('five'));
    let counter = 0;
    if (
      type === 'sema' ||
      type === 'week' ||
      type === 'mlwk' ||
      type === 'mwne' ||
      type === 'mlne' ||
      type === 'woch'
    ) {
      currentStorage.forEach((item) => {
        if (
          item.item_type === 'sema' ||
          item.item_type === 'week' ||
          item.item_type === 'mlwk' ||
          item.item_type === 'mwne' ||
          item.item_type === 'mlne' ||
          item.item_type === 'woch'
        ) {
          counter++;
        }
      });
    }

    if (type === 'actuvideo' || type === 'mquovideo') {
      currentStorage.forEach((item) => {
        if (item.item_type === 'actuvideo' || item.item_type === 'mquovideo') {
          counter++;
        }
      });
    }

    if (counter >= 2) {
      return false;
    } else {
      return true;
    }
  }
}
